// Whether a download nobody asked for should happen now. A catalogue delta is small, but it is still
// the device spending the person's data and battery unasked, so it waits when the browser says the
// person wants to save data or is on a cellular connection. Both signals come from the Network
// Information API, which not every browser has: where it is missing nothing is known and the update
// goes ahead (it is under 5 MB). Offline is not a blocker here: a check that cannot reach the edge
// fails on its own and is retried later.

/** Why a background update is held back. */
export type UpdateBlocker = "save-data" | "metered";

/** The two Network Information fields used, read without trusting the browser's type for them. */
function connection(): { saveData: unknown; type: unknown; effectiveType: unknown } | undefined {
  const info: unknown = Reflect.get(globalThis.navigator, "connection");
  if (typeof info !== "object" || info === null) return undefined;
  return {
    saveData: Reflect.get(info, "saveData"),
    type: Reflect.get(info, "type"),
    effectiveType: Reflect.get(info, "effectiveType"),
  };
}

/** What stops a silent update right now, if anything. */
export function updateBlocker(): UpdateBlocker | undefined {
  const info = connection();
  if (info?.saveData === true) return "save-data";
  if (info?.type === "cellular") return "metered";
  return undefined;
}

/** Whether the connection performs like 2G: too slow to fetch a catalogue nobody asked for yet. */
export function slowConnection(): boolean {
  const effective = connection()?.effectiveType;
  return effective === "slow-2g" || effective === "2g";
}
